@use '@/styles/tokens' as *;

.header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  margin-bottom: 20px;
  background: var(--surface-subtle);
  border-radius: 12px;
}

// Figma `30:471647`: the id column takes the spare width and truncates; the customer column keeps
// its natural width (capped at half the card) so a long id can never push it off the card (120966).
.payment {
  flex: 1 1 auto;
  min-width: 0;
}

.txn {
  font-weight: 600;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subtitle {
  margin-top: 4px;
  color: var(--text-secondary);
  font-size: 13px;
}

.customer {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 50%;
  align-items: flex-end;
  display: flex;
  text-align: right;
  gap: 4px;
  flex-direction: column;
  justify-content: space-between;
}

.customerInfo {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}

.customerName {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orderNumber {
  color: var(--text-secondary);
  font-size: 12px;
  white-space: nowrap;
}

// Timeline event: status chip on top, masked payment method stacked below (neutral colour so it
// isn't tinted by the shared Timeline's status colour). Matches Figma node 7522-303033.
.event {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.eventMethod {
  color: var(--text-primary);
  font-size: 16px;
}

.banner {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 12px;
  border-radius: 10px;
  background: $color-error-50;
  color: $color-stage-attention-text;
  font-size: 13px;
}
